import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function IsolatedCoroutineScope() {
  return CoroutineScope(EmptyCoroutineContext_instance);
}
//region block: exports
export {
  IsolatedCoroutineScope as IsolatedCoroutineScopensqylcikdcw7,
};
//endregion

//# sourceMappingURL=IsolatedCoroutineScope.mjs.map
